import FinancePage from './FinancePage';

export default FinancePage;